// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kpdu_dashboard_box_container__wmhhh {
  min-height: 227px;
  width: 400px;
  min-width: 380px;
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow:
    0 8px 13px -2px #00000014,
    0 17px 4px -14px #1b294a4a;
  justify-content: start;
  display: flex;
  flex-direction: column;
  font-family: Mulish, sans-serif;
  margin: 25px 25px;
}

.kpdu_dashboard_box_table__jKESb tr td:first-of-type,
.kpdu_dashboard_box_table__jKESb tr th:first-of-type {
  border-bottom: none;
}

.kpdu_dashboard_box_table__jKESb th {
  color: #f32735;
  font-weight: 600;
  font-size: 9px;
}

.kpdu_dashboard_box_table__jKESb tr td,
.kpdu_dashboard_box_table__jKESb tr th {
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #d9d9d9;
}

.kpdu_dashboard_box_value__S16ku {
  margin: 9px 19px;
  font-size: 13px;
  font-weight: 600;
  background-color: #f5f5f5;
  color: #a3a3a3;
  border-radius: 4px;
  width: 47px;
  min-width: 47px;
  height: 25px;
  min-height: 25px;
  vertical-align: middle;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.kpdu_dashboard_box_nickname__LF\\+aX {
  margin: 9px 19px;
  font-size: 13px;
  font-weight: 600;
  color: #88d36e;
  border-radius: 4px;
  width: 67px;
  min-width: 47px;
  height: 25px;
  min-height: 25px;
  vertical-align: middle;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  /* overflow: hidden; */
  /* white-space: nowrap; */
  /* text-overflow: ellipsis; */
  /* box-sizing: border-box; */
}

.kpdu_dashboard_box_output__x082C {
  background-color: #88d36e;
  border-radius: 5px 0 0 5px;
  width: 32px;
  min-width: 32px;
  height: 100%;
}

.kpdu_dashboard_box_output__x082C > div:first-of-type {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
}

.kpdu_dashboard_box_output__x082C > div:last-of-type {
  color: #429c23;
  font-size: 10px;
  font-weight: 600;
}

.kpdu_dashboard_box_headerContainer__iWgTy {
  min-height: 50px;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  font-size: 20px;
  color: #f32735;
  font-family: Mulish, sans-serif;
  text-align: left;
  padding: 10px 22px;
  font-weight: 700;
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.kpdu_dashboard_box_headerContainer__iWgTy:hover {
  background-color: rgba(243, 39, 53, 0.1);
}

.kpdu_dashboard_box_footerContainer__3nWqI {
  display: none;
  width: 100%;
  height: 25px;
  background: linear-gradient(180deg, #ffffff 12%, #d9d9d9 100%);
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/dashboard/components/kpdu_box/kpdu_dashboard_box.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;8BAE4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,8DAA8D;EAC9D,gCAAgC;EAChC,+BAA+B;AACjC","sourcesContent":[".container {\n  min-height: 227px;\n  width: 400px;\n  min-width: 380px;\n  background-color: #ffffff;\n  border-radius: 15px;\n  box-shadow:\n    0 8px 13px -2px #00000014,\n    0 17px 4px -14px #1b294a4a;\n  justify-content: start;\n  display: flex;\n  flex-direction: column;\n  font-family: Mulish, sans-serif;\n  margin: 25px 25px;\n}\n\n.table tr td:first-of-type,\n.table tr th:first-of-type {\n  border-bottom: none;\n}\n\n.table th {\n  color: #f32735;\n  font-weight: 600;\n  font-size: 9px;\n}\n\n.table tr td,\n.table tr th {\n  padding: 0;\n  margin: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.value {\n  margin: 9px 19px;\n  font-size: 13px;\n  font-weight: 600;\n  background-color: #f5f5f5;\n  color: #a3a3a3;\n  border-radius: 4px;\n  width: 47px;\n  min-width: 47px;\n  height: 25px;\n  min-height: 25px;\n  vertical-align: middle;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.nickname {\n  margin: 9px 19px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #88d36e;\n  border-radius: 4px;\n  width: 67px;\n  min-width: 47px;\n  height: 25px;\n  min-height: 25px;\n  vertical-align: middle;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* overflow: hidden; */\n  /* white-space: nowrap; */\n  /* text-overflow: ellipsis; */\n  /* box-sizing: border-box; */\n}\n\n.output {\n  background-color: #88d36e;\n  border-radius: 5px 0 0 5px;\n  width: 32px;\n  min-width: 32px;\n  height: 100%;\n}\n\n.output > div:first-of-type {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.output > div:last-of-type {\n  color: #429c23;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.headerContainer {\n  min-height: 50px;\n  border-top-right-radius: 15px;\n  border-top-left-radius: 15px;\n  font-size: 20px;\n  color: #f32735;\n  font-family: Mulish, sans-serif;\n  text-align: left;\n  padding: 10px 22px;\n  font-weight: 700;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.headerContainer:hover {\n  background-color: rgba(243, 39, 53, 0.1);\n}\n\n.footerContainer {\n  display: none;\n  width: 100%;\n  height: 25px;\n  background: linear-gradient(180deg, #ffffff 12%, #d9d9d9 100%);\n  border-bottom-right-radius: 15px;\n  border-bottom-left-radius: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `kpdu_dashboard_box_container__wmhhh`,
	"table": `kpdu_dashboard_box_table__jKESb`,
	"value": `kpdu_dashboard_box_value__S16ku`,
	"nickname": `kpdu_dashboard_box_nickname__LF+aX`,
	"output": `kpdu_dashboard_box_output__x082C`,
	"headerContainer": `kpdu_dashboard_box_headerContainer__iWgTy`,
	"footerContainer": `kpdu_dashboard_box_footerContainer__3nWqI`
};
export default ___CSS_LOADER_EXPORT___;
